module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$cookies", "session", "storage", "$location", function (Service, $cookies, session, storage, $location) {
        new Service({
            name: 'ltpalogin',
            group: 'wcs',
            //FIXME: store id needs to be dynamic here...
            url: '/wcs/x-services/resources/store/:storeId/login/ltpalogin',
            postData: function (payload, user) {
                if(session.data.loginData && session.data.loginData.login && session.data.loginData.password) {
                    this.headers.Authorization = "Basic "+b64.atob(session.data.loginData.login+":"+session.data.loginData.password);
                }

                if(user && user.username && user.password){
                    this.headers.Authorization = "Basic "+window.btoa(user.username+":"+user.password);
                }
                
                return this.post({
                    "payload": payload
                });
            },
            getLoginData: function() {
                return session.data.loginData;
            },
            getCommerceData: function() {
                var data = null;
                var loginData = this.getLoginData();
                if(loginData) {
                    data = {};
                    data.personalizationID = loginData.personalizationID;
                    data.userId = loginData.userId;
                    data.WCToken = loginData.WCToken;
                    data.WCTrustedToken = loginData.WCTrustedToken;
                }

                return data;
            },
            storeCommerceData: function () {
                var toStore = this.getCommerceData();
                var authTokenCookieName = "CommerceTokens";

                var currentDomain = $location.host();
                var currentDomainArray = currentDomain.split(".");
                while(currentDomainArray.length > 2) {
                    currentDomainArray.shift();
                }
                currentDomain = currentDomainArray.join(".");

                if(toStore) {
                    $cookies.put(authTokenCookieName, JSON.stringify(toStore), {path: '/', "domain": currentDomain});
                    storage.set(authTokenCookieName, JSON.stringify(toStore));
                }

                return toStore;
            },
            /**
             * Method which takes an entitlement value from entitlementsConfig
             * and returns whether the currently logged in user has that entitlement.
             *
             * @param entitlement
             * @returns boolean
             */
            hasEntitlement: function (entitlement, loginData) {
                var selectedAgency = loginData.selectedAgency || session.data.loginData.selectedAgency;
                if (selectedAgency) {
                    var entitlements = selectedAgency.entitlements;
                    return angular.forEach(entitlements, function(item) {
                        return item.descriptionKey === entitlement && item.hasEntitlement;
                    });
                } else {
                    return false;
                }
            },
            /**
             *
             * Method which takes an array of entitlement values from entitlementsConfig
             * and returns whether the user has ALL entitlements passed.
             *
             * @param {Array} entitlements
             * @returns boolean
             */
            hasEntitlements: function (entitlements, loginData) {
                var selectedAgency = loginData.selectedAgency || session.data.loginData.selectedAgency;
                if (selectedAgency && selectedAgency.entitlements) {
                    var usersEntitlements = selectedAgency.entitlements;
                    return angular.forEach(entitlements, function(entitlement) {
                        return angular.forEach(usersEntitlements, function(userEntitlement) {
                            return userEntitlement.descriptionKey === entitlement && userEntitlement.hasEntitlement;
                        });
                    });
                } else {
                    return false;
                }
            },
            // Method to checkEntitlements
            hasClientEntitlement: function(loginData){
                var hasClient = true;
                if(loginData.selectedAgency){
                    if(this.hasEntitlement("RetailStore", loginData)) {
                        hasClient = false;
                    }
                    if(this.hasEntitlement("TelesalesAgentDP", loginData)) {
                        hasClient = false;
                    }
                }else{
                    hasClient = false;
                }
                return hasClient;
            },

            hasAgencyEntitlement: function(loginData){
                var hasAgency = true;
                if(loginData.selectedAgency){
                    if(this.hasEntitlement("TelesalesAgentDP", loginData)) {
                        hasAgency = false;
                    }
                }else{
                    hasAgency = false;
                }
                return hasAgency;
            },

            //helper function to quickly determine if a user has a telesales entitlement or not. Returns a boolean value.
            hasTelesalesEntitlement: function(){
                var hasTelesales = false;
                var selectedAgency = session.data.loginData.selectedAgency;

                hasTelesales = this.hasEntitlement("TelesalesAgentDP");

                return hasTelesales;
            },

            hasRetailStoreEntitlement: function(){
                var hasRetailStore = false;
                var selectedAgency = session.data.loginData.selectedAgency;

                hasRetailStore = this.hasEntitlement("RetailStore");

                return hasRetailStore;
            },

            getUserType: function() {
                var typeToReturn = {};
                var roleAttribute = "UserRole"
                var attr = {}, i, attributeName;
                var attrList = session.data.loginData.contextAttribute;
                if (attrList) {
                    for (i = 0; i < attrList.length; i += 1) {

                        attributeName = attrList[i].attributeName;

                        if (attributeName === roleAttribute) {
                            attr.storeId = attrList[i].attributeValue[0].storeId;
                            attr.actorType = attrList[i].attributeValue[0].value[0];
                        }
                    }

                    if (!attr.actorType && (this.getUser().zipCode || this.getUser().county)) { // If there's no actor type but we do have a defined zip code or county, this is a prospect
                        attr.storeId = "0";
                        attr.actorType = "PROS";
                    }
                    typeToReturn = attr;
                }
                return typeToReturn;
            },
            isUserAgent: function() {
                var userType = this.getUserType;
                if(userType && userType.actorType === "AGENT") {
                    return true;
                } else {
                    return false;
                }
            },
            isUserAgentAdmin: function () {
                var userType = this.getUserType;
                if(userType && userType.actorType === "AGENCY_ADMIN") {
                    return true;
                } else {
                    return false;
                }
            },
            isUserInternalUser: function () {
                var userType = this.getUserType;
                if(userType && userType.actorType === "INTERNAL") {
                    return true;
                } else {
                    return false;
                }
            },
            hasMedicareIndvEntitlement: function() {
                var self = this,
                hasMedIndv = false,
                selectedAgency = self.getSelectedAgency();
                if(selectedAgency){
                   
                    angular.forEach(selectedAgency.entitlements, function(entitlement){
                        if((entitlement.descriptionKey === "SnrMktsInd" ||  entitlement.descriptionKey === "SnrMktsIndMedSup") && entitlement.hasEntitlement){
                            hasMedIndv = true;
                        }
                    });
                }else{
                    hasMedIndv = false;
                }
                return hasMedIndv; 
            },
            isUserMedicareProducer: function() {
                var self = this, isMedicareProducer = false, userType = this.getUserType;

                if(userType && (userType.actorType === "AGENT" || userType.actorType === "AGENCY_ADMIN" || userType.actorType === "INTERNAL") && self.hasMedicareIndvEntitlement()){
                    isMedicareProducer = true;
                }
                
                return isMedicareProducer; 
            },
            getSelectedAgency: function () {
                var loginData = session.data.loginData;
                var selectedAgency = loginData ? loginData.selectedAgency : null;
                return selectedAgency;
            }
        });
    }]);
};